import { render, staticRenderFns } from "./CeldaNFC.vue?vue&type=template&id=0eb134a1&scoped=true"
import script from "./CeldaNFC.vue?vue&type=script&lang=js"
export * from "./CeldaNFC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb134a1",
  null
  
)

export default component.exports